import { useState, useEffect, useCallback } from "react";

const SCROLL_AMOUNT = 200;

const useSuggestedQuestionsCarousel = (scrollRef) => {
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateScrollState = useCallback(() => {
        const el = scrollRef.current;
        if (!el) return;
        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }, [scrollRef]);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        updateScrollState();
        el.addEventListener('scroll', updateScrollState);
        return () => el.removeEventListener('scroll', updateScrollState);
    }, [scrollRef, updateScrollState]);

    const scroll = useCallback((direction) => {
        const el = scrollRef.current;
        if (!el) return;
        const offset = direction === 'left' ? -SCROLL_AMOUNT : SCROLL_AMOUNT;
        el.scrollBy({ left: offset, behavior: 'smooth' });
    }, [scrollRef]);

    return { canScrollLeft, canScrollRight, scroll };
};

export default useSuggestedQuestionsCarousel;
